import { SWITCH_MODE } from "./types";

export const switchMode = () => ({
  type: SWITCH_MODE,
});
